export default __webpack_public_path__ + "static/lpay-asia-closure-hero-banner-060b96b862fa536e9ac3966c9be620ba.webp";